<template>
  <div id="app">
    <!-- <keep-alive :include="cachedPages">
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive> -->
    <!-- <router-view v-if="!$route.meta.keepAlive" /> -->
    <router-view />
    <!-- 停机通知 开始 -->
    <van-dialog
      v-model="noticeShow"
      title=""
      :show-confirm-button="false"
      :show-cancel-button="false"
      class-name="notice-dialog"
    >
      <div class="notice-dialog-content">
        <div class="notice-header">
          <van-icon name="volume-o" class="notice-icon" />
          <span class="notice-title">重要通知</span>
        </div>
        <div class="notice-body">
          <div v-html="noticeContent" class="notice-text"></div>
        </div>
        <div class="notice-footer">
          <van-button
            type="default"
            round
            @click="closeNotice"
            class="notice-btn notice-btn-close"
          >
            我知道了
          </van-button>
        </div>
      </div>
    </van-dialog>
    <!-- 停机通知 结束 -->
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      noticeShow: false,
      noticeContent: ""
    };
  },
  computed: {
    cachedPages() {
      return this.$route.matched
        .filter(route => route.meta.keepAlive)
        .map(route => route.name);
    }
  },
  mounted() {
    this.noticeShow = false;
    this.getRemoteTxt();
  },
  methods: {
    closeNotice() {
      this.noticeShow = false;
    },
    async getRemoteTxt() {
      try {
        // 远程地址
        const url = "http://wap.ptty.com.cn/wap/config.txt";

        // 发起请求
        const res = await fetch(url);
        const text = await res.text();
        console.log("配置文件内容：" + text);
        if (text.length > 0) {
          this.noticeShow = true;
          this.noticeContent = text;
        }

        // 赋值给页面显示
        this.content = text;
      } catch (err) {
        console.log("读取失败：", err);
      }
    }
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
/* 补充通知弹出框样式 */
.notice-dialog-content {
  padding: 0;
}

.notice-header {
  background: linear-gradient(135deg, #ff9800 0%, #ff6b00 100%);
  padding: 20px;
  text-align: center;
  border-radius: 8px 8px 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.notice-icon {
  font-size: 24px;
  color: #fff;
  margin-right: 8px;
  animation: ring 2s ease-in-out infinite;
}

@keyframes ring {
  0%,
  100% {
    transform: rotate(0deg);
  }
  10%,
  30% {
    transform: rotate(-10deg);
  }
  20%,
  40% {
    transform: rotate(10deg);
  }
}

.notice-title {
  font-size: 18px;
  font-weight: 600;
  color: #fff;
}

.notice-body {
  padding: 20px;
  max-height: 400px;
  overflow-y: auto;
  background: #fff;
}

.notice-text {
  line-height: 1.8;
  font-size: 15px;
  color: #333;
  text-align: left;
}

.notice-text p {
  margin: 10px 0;
}

.notice-text strong {
  color: #ff9800;
  font-weight: 600;
}

.notice-footer {
  padding: 15px 20px 20px;
  background: #fff;
  border-radius: 0 0 8px 8px;
  display: flex;
  gap: 10px;
}

.notice-btn {
  flex: 1;
  font-size: 16px;
  font-weight: 500;
  height: 44px;
}

.notice-btn-close {
  background: #f5f5f5;
  color: #666;
  border: 1px solid #e0e0e0;
}

.notice-btn-detail {
  background: linear-gradient(135deg, #ff9800 0%, #ff6b00 100%);
  border: none;
  box-shadow: 0 4px 12px rgba(255, 152, 0, 0.4);
}
</style>



// WEBPACK FOOTER //
// src/App.vue